module.exports = __webpack_public_path__ + "img/1561398898.dce72a60.jpg";